import {gql, useLazyQuery, useQuery} from "@apollo/client";
import {API_CLIENT} from "@services/graphql/client";

export const GET_DUPLICATE_APPOINTMENTS = gql`
  query GetDuplicateAppointments($input: DuplicateAppointmentsRequest) {
    duplicateAppointments(input: $input)
      @rest(
        type: "DuplicateAppointmentResponse"
        method: "POST"
        path: "/hib/getDuplicateAppointments"
      ) {
      duplicates {
        id
        slotTime
        locationName
        locationSlug
        locationTimezone
        addressFirstLine
        addressCity
        addressState
      }
    }
  }
`;

export type DuplicateAppointment = {
  id: string;
  slotTime: number;
  locationName?: string;
  locationSlug?: string;
  locationTimezone?: string;
  addressFirstLine?: string;
  addressCity?: string;
  addressState?: string;
};

export type DuplicateAppointments = {
  duplicates: DuplicateAppointment[];
};

export type DuplicateAppointmentsQuery = {
  duplicateAppointments: DuplicateAppointments;
};

export type DuplicateAppointmentRequest = {
  patientId: string;
  practiceId: string;
  apptReasonId: string;
  specialtyId: string;
  slotIds: string[];
};

type DuplicateAppointmentVariables = {
  input: DuplicateAppointmentRequest;
};

export const useFetchDuplicateAppointments = (variables: DuplicateAppointmentVariables) =>
  useQuery<DuplicateAppointmentsQuery, DuplicateAppointmentVariables>(GET_DUPLICATE_APPOINTMENTS, {
    variables,
    context: {
      clientName: API_CLIENT,
    },
  });

export const useFetchDuplicateAppointmentsLazy = () =>
  useLazyQuery<DuplicateAppointmentsQuery, DuplicateAppointmentVariables>(
    GET_DUPLICATE_APPOINTMENTS,
    {
      context: {
        clientName: API_CLIENT,
      },
    },
  );
